import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { uuidv4 } from "utils";

const NRadioButtons = ({
  key,
  dataset,
  isDisabled,
  onChange,
  keyPosition,
  lastKeyPosition,
  style,
}) => {
  return (
    <div className="mt-2" style={style}>
      <div>{dataset.text}</div>
      <div className="mt-2">
        {dataset.answers.map((item, key) => {
          return (
            <div
              className="mt-1 d-flex align-items-center"
              key={`resu-${key}-${item.id}`}
            >
              <Form.Check
                id={`resu-${uuidv4(4)}-${item.id}`}
                name={`result-radiobuttons-questions-${dataset.id}`}
                type="radio"
                label={item.text}
                value={item.text}
                onChange={(event) =>
                  onChange(key, event.target.value, dataset, item)
                }
                custom
              />
              {item?.info && item?.info !== "" && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-${item.id}`}>{item?.info}</Tooltip>
                  }
                >
                  <FontAwesomeIcon
                    className="text-muted ml-2"
                    icon={faInfoCircle}
                  />
                </OverlayTrigger>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NRadioButtons;
